import { Box, LinearProgress, Typography } from '@mui/material';
import React, { FC, useState } from 'react'
import styles from './ExcelUploadProgress.module.scss';
import { getProgressColor, getStatusIcon, getStatusText } from '@utils/progressLogic';

interface ExcelUploadProgressProps {
  uploadStatus: "idle" | "uploading" | "success" | "error";
  uploadProgress: number;
  currentFileName?: string;
}

const ExcelUploadProgress: FC<ExcelUploadProgressProps> = ({ 
  uploadStatus, 
  uploadProgress, 
  currentFileName 
}) => {
  /* --------------------------------------------------------------------------
   * Render
   * -------------------------------------------------------------------------- */
  return (
    <Box className={styles.progressSection}>
      {/* Progress Header - Status Icon, Text, and Percentage */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        {/* Left Side: Status Icon and Text */}
        <Box display="flex" alignItems="center" gap={1}>
          {/* Status Icon - Changes based on upload status */}
          {getStatusIcon(uploadStatus)}

          {/* Status Text - Shows current status and filename */}
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            {getStatusText(uploadStatus, currentFileName)}
          </Typography>
        </Box>

        {/* Right Side: Progress Percentage */}
        <Typography variant="body2" color="textSecondary">
          {uploadProgress}%
        </Typography>
      </Box>

      {/* Progress Bar - Color changes based on status */}
      <LinearProgress
        variant="determinate"
        value={uploadProgress}
        color={getProgressColor(uploadStatus)}
        style={{ height: 8, borderRadius: 4 }}
      />
    </Box>
  );
}

export default ExcelUploadProgress